var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewsCategory = function SvgReviewsCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reviews-category_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#reviews-category_svg__b)",
    d: "M36.725 30.167H11.078c-.794 0-1.437.643-1.437 1.437v.168c0 .793.643 1.437 1.437 1.437h25.647c.794 0 1.438-.644 1.438-1.437v-.168c0-.794-.644-1.437-1.438-1.437"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reviews-category_svg__c)",
    d: "M38.357 27.795a5.9 5.9 0 0 0-.292-1.775c-.874-2.494-2.917-4.654-5.216-5.905a8.3 8.3 0 0 0-2.893-.957c-5.1-.664-5.1-4.347-7.375-4.347-.716.005-1.175.615-1.228 1.395-.02 1.8-1.809 3.255-4.014 3.255s-3.994-1.455-4.02-3.255c-.047-.781-.577-1.395-1.222-1.395h-.683c-.979 0-1.773.977-1.773 2.182v11.39c0 1.003.66 1.817 1.476 1.817h25.57c1.296 0 1.679-1.204 1.668-2.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reviews-category_svg__d)",
    d: "M30.64 19.535v2.873a1.197 1.197 0 0 0 2.395 0v-2.873a1.197 1.197 0 1 0-2.394 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reviews-category_svg__e)",
    d: "M26.453 18.014v4.394a1.197 1.197 0 0 0 2.395 0v-4.394a1.197 1.197 0 0 0-2.395 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reviews-category_svg__b",
    x1: 16.433,
    x2: 31.373,
    y1: 24.219,
    y2: 39.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D98EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C5AE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reviews-category_svg__c",
    x1: 11.251,
    x2: 32.226,
    y1: 14.345,
    y2: 35.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FBAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reviews-category_svg__d",
    x1: 31.838,
    x2: 31.838,
    y1: 18.336,
    y2: 23.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125FE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reviews-category_svg__e",
    x1: 27.65,
    x2: 27.65,
    y1: 16.816,
    y2: 23.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B97EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125FE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "reviews-category_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgReviewsCategory;